<div class="n-breadcrumb d-flex align-items-center justify-content-between">
  <ol class="breadcrumb m-0 bg-transparent p-0">
    <li class="breadcrumb-item"><a href="/#/dealer/home">Home</a></li>
    <li class="breadcrumb-item"><a href="/#/subscriptions/managesubscriptions">Manage Subscriptions</a></li>
    <li class="breadcrumb-item active">{{pageTitle}}</li>
  </ol>

</div>
<div class="tcard">
  <div class="tcard-header pt-4 px-4 pb-2">
    <div class="table-header d-flex align-items-center justify-content-between col-md-12">
      <div class="table-title mt-1">
        <b>
          <h3 class="m-0 font-weight-light">{{pageTitle}}</h3>
        </b>
      </div>
    </div>
  </div>
  <div class="tcard-body p-4 col-md-121">
    <form class="editdealer-form" novalidate [formGroup]="editForm">

      <div class="col-md-12">

              <div class="row">
          <div class="col-md-3 col-lg-2 form-group">
            <strong class="mt-2 pt-1 d-block">Subscription Name :</strong>
          </div>
          <div class="form-group col-md-9 col-lg-5">
            <div class="row d-flex">
                <input type="text" class="form-control" formControlName="SubscripitonName">
            </div>
          </div>
          <div style="margin-left: 100px" *ngIf="editForm.controls.SubscripitonName.status == 'INVALID' && validationmsg" class="text-danger">
            Please select subscripiton name
          </div>
        </div>
        <!-- <div class="row">
          <div class="col-md-3 col-lg-2 form-group">
            <strong class="mt-2 pt-1 d-block">TimeZone :</strong>
          </div>
          <div class="form-group col-md-9 col-lg-6">
            <div class="row d-flex">
              <div class="radio-custom radio-primary col-md-4 col-lg-3" *ngFor="let tm of timezones">
                <input type="radio" class="form-control custom-control-input" id="{{tm.TimezoneId}}"
                   [ngModelOptions]="{standalone: true}" value="{{tm.Code}}"
                  formControlName="timezone">
                <label class="custom-control-label" for="{{tm.TimezoneId}}">{{tm.Code}}</label>
              </div>
            </div>
          </div>
          <div *ngIf="editForm.controls.timezone.status == 'INVALID' && validationmsg" class="text-danger">
            Please select timezone
          </div>
        </div> -->
        <div class="row">
          <div class="col-md-3 col-lg-2 form-group" style="padding-right: 5px;">
            <strong class="mt-2 pt-1 d-block">Select Client :</strong>
          </div>
          <div class="form-group col-md-9 col-lg-6">
            <div class="row d-flex">
              <div class="radio-custom radio-primary col-md-4 col-lg-3" *ngFor="let client of clients">
                <input class="form-control" type="radio" id="{{client.ClientName}}" formControlName="client"
                  (change)="clientCheck(client.ClientId)" (change)="clicktogetdealer()" class="custom-control-input  form-control"
                  value="{{client.ClientId}}">
                <label class="custom-control-label" for="{{client.ClientName}}">{{client.ClientName}}</label>
              </div>
            </div>

          </div>
          <div *ngIf="editForm.controls.client.status == 'INVALID' && validationmsg" class="text-danger">
            Please select client
          </div>
        </div>
        


        
        <div class="row">
          <div class="col-md-3 col-lg-2 form-group">
            <strong class="mt-2 pt-1 d-block"> Source Type :</strong>
          </div>
          <div class="form-group col-md-9 col-lg-6">
            <div class="row d-flex">
              <div class="radio-custom radio-primary col-md-4 col-lg-3" *ngFor="let sourceType of sourceTypes">
                <input class="form-control" type="radio" id="{{sourceType.SubscriptionTypeName}}" formControlName="SourceType"
                  name="SourceType" class="custom-control-input  form-control" value="{{sourceType.SubscriptionTypeId}}"
                  (click)="onChangeSelection(sourceType.SubscriptionTypeName)">
                <label class="custom-control-label"
                  for="{{sourceType.SubscriptionTypeName}}">{{sourceType.SubscriptionTypeName}}</label>
              </div>
            </div>
          </div>        
          <div *ngIf="editForm.controls.SourceType.status == 'INVALID' && validationmsg || editForm.controls.SourceType.touched && editForm.controls.SourceType.hasError('noValue')" class="text-danger">
            Please select source type
          </div>
        </div>
      
        <div class="row" *ngIf="isShowSource" >
          <div class="col-md-3 col-lg-2 form-group">
          </div>
          <div class="form-group border col-md-9 col-lg-6">
            <div class="row d-flex ml-1" >
              <div class="radio-custom radio-primary col-md-4 col-lg-4" *ngFor="let source of sources">
                <input type="radio" id="{{source.SourceName}}" formControlName="Source" name="Source"
                  (change)="clicktogetdealer()" class="custom-control-input" value="{{source.DataSourceId}}">
                <label class="custom-control-label" for="{{source.SourceName}}">{{source.SourceName}}</label>
              </div>
            </div>
          </div>
          <div *ngIf="editForm.controls.Source.status == 'INVALID' && validationmsg" class="text-danger">
            Please select source 
          </div>
        </div>
        <div class="row" *ngIf="showFiletypes">
          <div class="col-md-3 col-lg-2 form-group">
            <strong class="mt-2 pt-1 d-block">Data :</strong>
          </div>
          <div class="form-group col-md-9 col-lg-6">
            <div class="row d-flex">
              <div class="radio-custom radio-primary col-md-4 col-lg-3" *ngFor="let fileType of fileTypes">
                <input type="radio" class="form-control custom-control-input" id="{{fileType.FileTypeName}}"
                  formControlName="ClientFileType" (change)="clicktogetdealer()" value="{{fileType.FileTypeId}}">
                <label class="custom-control-label" for="{{fileType.FileTypeName}}">{{fileType.FileTypeName}}</label>
              </div>
            </div>
          </div>
          <div *ngIf="editForm.controls.ClientFileType.status == 'INVALID' && validationmsg" class="text-danger">
            Please select data
          </div>
        </div>
        <div class="row">
          <div class="col-md-3 col-lg-2 form-group">
            <strong class="mt-2 pt-1 d-block">Schedule Options :</strong>
          </div>
          <div class="form-group col-md-9 col-lg-6 ">
            <div class="row d-flex">
              <div class="form-group">
                  <p-selectButton class="weekdays-group" icon="fa-check" (onChange)="ScheduleSelection()" [options]="ScheduleType" [(ngModel)]="selectedType"
                      [ngModelOptions]="{standalone: true}"></p-selectButton>
              </div>
              <div class="row Daily-schedule onetime-chk col-md-12" *ngIf="divOneTime">
                <div class="border" style="padding: 8px;">
                  <h6 class="form-group  col-md-12" i18n>One Time Schedule </h6>
                <div class="form-group col-md-12" >
                  <strong><label>Date Range:</label></strong><br>
                  <p-dropdown (onChange)="customSelect($event)" [options]="DateRangeOptions" formControlName="DateRange" ></p-dropdown>
                </div>
                <div class="form-group col-md-12" *ngIf="isCustomDate">
                    <strong><label>From Date:</label></strong>
                    <input class="form-control col-md-12" min="{{pastDate}}" max="{{today}}"
                      formControlName="custom_date" type="date">
                  </div>
                </div>
                <div  class="text-danger">
                  {{onetimeerrormsg}}
                </div>
              </div>
              <div class="row Daily-schedule weekly-chk col-md-12 " *ngIf="divDaily">
                <div class="border" style="padding: 8px;">
                  <h6 i18n>Daily Schedule </h6>
                  <div class="form-group">
                      <div class="radio-custom radio-primary">
                          <input type="radio" id="fol_days" class="custom-control-input" name="DailySchedule" value="followingDays" formControlName="DailySchedule" (change)="ScheduleSec()">
                          <label for="fol_days" class="custom-control-label">
                              <strong i18n>On the following days:</strong>
                          </label>
                      </div>
                  </div>
                  <div class="form-group" [ngClass]="{'has-error': displayMessage.Fwd }">
                      <p-selectButton class="weekdays-group" [options]="WeekDays" formControlName="Fwd" [(ngModel)]="selectedDlyWeekDays" multiple="multiple"
                          (onChange)="ScheduleSec()"></p-selectButton>
                      <span class="help-block" *ngIf="displayMessage.Fwd"> {{displayMessage.Fwd}}</span>
                  </div>
  
                  <div class="">
                      <div class="radio-custom radio-primary">
                          <input type="radio" id="sc_EveryWeekDay" value="everyWeekday" name="DailySchedule" formControlName="DailySchedule" (change)="ScheduleSec()">
                          <label for="sc_EveryWeekDay">
                              <strong i18n>Every weekday</strong>
                          </label>
                      </div>
                  </div>
  
                  <div class="form-group">
                      <div class="radio-custom radio-primary" [ngClass]="{'has-error': displayMessage.afterdays }">
                          <input type="radio" id="sc_Repeat" value="noOfdays" name="DailySchedule" formControlName="DailySchedule" (change)="ScheduleSec()">
                          <label for="sc_Repeat">
                              <strong i18n>Repeat after this number of days </strong>
                          </label>
                          <input type="text" class="form-control" formControlName="afterdays" (keypress)="_keyPress($event)" (keyup)="DateValid(editForm.controls.afterdays.value)"
                              style="width:70px;display: inline-block; vertical-align: middle; margin-left:5px;"
                          />
                          <span class="help-block" *ngIf="displayMessage.afterdays"> {{displayMessage.afterdays}}</span>
                          <span class="help-block" *ngIf="editForm.controls.afterdays.value==0"> {{displayMessage.error}}</span>
                      </div>
  
                  </div>
                </div>
              </div>
              <!-- <div class="row Daily-schedule weekly-chk col-md-12" *ngIf="divWeekly" (change)="ScheduleSec()">
                <div class="border" style="padding: 8px;">
                <h6 i18n>Weekly Schedule </h6>
                <h6 i18n>Every Week on: </h6>
                <div class="form-group" [ngClass]="{'has-error': displayMessage.Wds }">
                    <p-selectButton class="weekdays-group" [options]="WeekDays" formControlName="Wds" (onChange)="ScheduleSec()" [(ngModel)]="selectedWklyWeekDays"
                        multiple="multiple"></p-selectButton>
                    <span class="help-block" *ngIf="displayMessage.Wds"> {{displayMessage.Wds}}</span>
                </div>
                <h6 i18n>Repeat Every </h6>
                <div class="form-group">
                    <select class="form-control" style="width:77px; display: inline-block;" formControlName="repeatEveryWk">
                        <option value="1">1 </option>
                        <option value="2">2 </option>
                        <option value="3">3 </option>
                        <option value="4">4 </option>
                        <option value="5">5 </option>
                    </select>
                    <label style="padding-left: 15px;" i18n>Week(s)</label>
                </div>
              </div>
            </div>
            <div class="row Daily-schedule monthly-chk col-md-12" *ngIf="divMonthly" (onChange)="ScheduleSec()">
              <div class="border" style="padding: 8px;">
              <h6 i18n>Monthly Schedule </h6>
              <h6 i18n>Every Month on: </h6>
              <div class="form-group" [ngClass]="{'has-error': displayMessage.Ms }">
                  <p-selectButton class="weekdays-group" [options]="Months" [(ngModel)]="selectedMonths" formControlName="Ms" multiple="multiple"
                      (onChange)="ScheduleSec()"></p-selectButton>
                  <span class="help-block" *ngIf="displayMessage.Ms"> {{displayMessage.Ms}}</span>
              </div>
              <div class="form-group">
                  <div class="radio-custom radio-primary" style="display: inline-block; padding-right: 15px;">
                      <input type="radio" class="ng-untouched ng-pristine ng-valid" value="DayOfMonth" formControlName="DayOfMonth" checked="">
                      <label>
                          <strong i18n>Day of the Month</strong>
                      </label>
                  </div>
                  <select class="form-control" style="width: 77px; display: inline-block;" formControlName="dayOfMonth">
                      <option value="1">1</option>
                      <option value="2">2</option>
                      <option value="3">3</option>
                      <option value="4">4</option>
                      <option value="5">5</option>
                      <option value="6">6</option>
                      <option value="7">7</option>
                      <option value="8">8</option>
                      <option value="9">9</option>
                      <option value="10">10</option>
                      <option value="11">11</option>
                      <option value="12">12</option>
                      <option value="13">13</option>
                      <option value="14">14</option>
                      <option value="15">15</option>
                      <option value="16">16</option>
                      <option value="17">17</option>
                      <option value="18">18</option>
                      <option value="19">19</option>
                      <option value="20">20</option>
                      <option value="21">21</option>
                      <option value="22">22</option>
                      <option value="23">23</option>
                      <option value="24">24</option>
                      <option value="25">25</option>
                      <option value="26">26</option>
                      <option value="27">27</option>
                      <option value="28">28</option>
                      <option value="29">29</option>
                      <option value="30">30</option>
                      <option value="31">31</option>
                  </select>
              </div>
            </div>
          </div> -->
          </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-3 col-lg-2" style="padding-right: 5px;">
            <strong class="mt-2 pt-1 d-block">Select Dealers :</strong>
          </div>
          <div class="col-md-12 col-lg-6 form-group form-field  manual-select">
            <div class="row1" style="margin-left: -15px">
              <p-multiSelect class="form-multiselect"  [panelStyle]="{minWidth:'12em'}" [options]="dealerlst" 
                formControlName="selectedDealers" [(ngModel)]="selectedDealerlst" placeholder="Choose Dealers">
              </p-multiSelect>
            </div>
          </div>
          <div *ngIf="editForm.controls.selectedDealers.touched != true && validationmsg || editForm.controls.selectedDealers.hasError('noValue') && editForm.controls.selectedDealers.invalid " class="text-danger ">
            Please select dealers
          </div>
        </div>
      </div>
      <div class="text-right btn-footer">
        <label *ngIf="msgSuccess" class="{{msgclass}}">{{Message}} </label>
        <button type="submit" class="btn btn-light py-2 px-4" [routerLink]="['/subscriptions/managesubscriptions']">
          <i class="icon md-arrow-left mr-2"></i>Cancel</button>
        <button type="submit" class="btn btn-primary py-2 px-4" (click)="submitSubscription()"><i class="la la-check mr-2"></i> Save</button>
      </div>
    </form>
  </div>
</div>
<style>
  .table-bordered {
    border: 0px;
  }
  .mytable1 th:nth-child(2) {
    width: 570px;
  }
  .mytable1 th:nth-child(4) {
    width: 98px;
  }

  .mytable1 th:nth-child(5) {
    width: 134px;
  }
  .ui-tabview-panels {
    min-height: 280px !important;
    max-height: 400px !important;
  }
  .ui-multiselect-panel .ui-multiselect-header .ui-multiselect-filter-container {
    margin-left: 10px !important;
  }
</style>